export default function FooterSection() {
  return (
    <footer id="contact" className="bg-amber-900 text-white py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-2">
            <img src="https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/767f58c2250624902df30344d9bb9bad.png" alt="ACBuy2026" className="h-10 w-auto object-contain mb-4" />
            <p className="text-amber-200 text-sm leading-relaxed max-w-xs">
              ACBuy Spreadsheet 2026 — the most comprehensive replica shopping database. Better than hipobuy spreadsheet, updated daily with 100,000+ products.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-reddit-line","ri-discord-line","ri-telegram-line","ri-twitter-x-line"].map((icon) => (
                <a key={icon} href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-amber-800 hover:bg-amber-600 rounded-md transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-300 mb-4">Categories</h4>
            <ul className="space-y-2">
              {["Shoes","Hoodies/Sweaters","T-Shirts","Jackets","Pants/Shorts","Accessories"].map((c) => (
                <li key={c}><a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-amber-200 hover:text-white text-sm transition-colors cursor-pointer">{c}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-300 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-amber-200 hover:text-white text-sm transition-colors cursor-pointer">Home</a></li>
              <li><a href="#articles" className="text-amber-200 hover:text-white text-sm transition-colors cursor-pointer">SEO Articles</a></li>
              <li><a href="#about" className="text-amber-200 hover:text-white text-sm transition-colors cursor-pointer">About</a></li>
              <li><a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-amber-200 hover:text-white text-sm transition-colors cursor-pointer">Main Store</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-amber-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-amber-300 text-xs">© 2026 acbuy2026.net — ACBuy Spreadsheet 2026. All rights reserved.</p>
          <p className="text-amber-400 text-xs">For entertainment purposes. Visit <a href="https://repsw2c.com/" target="_blank" rel="nofollow noopener noreferrer" className="underline hover:text-white cursor-pointer">repsw2c.com</a></p>
        </div>
      </div>
    </footer>
  );
}
